import { createSelectorPathBuilder } from '@/checkout-instore-legacy/utils/selectorHelper'

export const customerSelector = {
  this: (state) => state && state.customer,
}

export const customerProfileSelector = createSelectorPathBuilder(
  customerSelector.this,
  (customer) => {
    const profile =
      customer.profile && customer.profile.document && customer.profile.email
        ? { ...customer.profile }
        : null
    if (profile) {
      profile.email = profile.email.data ? profile.email.data : profile.email
      profile.document = profile.document.data
        ? profile.document.data
        : profile.document
    }
    return profile
  }
)

export const returnExchangeSelector = createSelectorPathBuilder(
  (state) => state.returnExchange
)

export const giftCardShouldPreSelectExchangeSelector = createSelectorPathBuilder(
  returnExchangeSelector,
  (returnExchange) => returnExchange.giftCardPromise.shouldPreSelect
)
